import { tss } from 'tss-react';

export const useStyles = tss.create(() => ({
  font: {
    //Everything after Roboto is the same font-family as the web app;
    fontFamily: 'Roboto, Arial, Verdana, Helvetica, sans-serif',
  },
  launcherIcon: {
    '--una-app-launcher-icon-color': '#092640',
    '--una-app-launcher-icon-background-color-hover': '#E7E7E7',
    padding: 10,
  },
  launcherIconSandbox: {
    '--una-app-launcher-icon-color': '#092640',
    '--una-app-launcher-icon-background-color-hover': '#EFC6DA',
    padding: 10,
  },
}));
